import { ListFilterIcon } from 'lucide-react';

export const FilterBars = ListFilterIcon;
